import { render, staticRenderFns } from "./ad_desc_collapse.vue?vue&type=template&id=b4a103e8"
import script from "./ad_desc_collapse.vue?vue&type=script&lang=js"
export * from "./ad_desc_collapse.vue?vue&type=script&lang=js"
import style0 from "./ad_desc_collapse.vue?vue&type=style&index=0&id=b4a103e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports